import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import NavbarComp from '../../shared/components/Navbar';
import { useCategories } from './hooks/useCategories';
import { IoAddCircleOutline } from 'react-icons/io5';
import CategoriesTable from './components/CategoriesTable';
import CategoriesModalAdd from './components/CategoriesModalAdd';

const CategoriesPage = () => {

  const {
    categories,
    loading,
    error,
    addCategories,
    editCategories,
    fetchCategoriesById,
    fetchCategories,
    removeCategories,
    updateOnActive,
    alert } = useCategories();

  const [showModal, setShowModal] = useState(false);

  const [editingData, setEditingData] = useState(null);

  const handleOpenModal = (row) => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingData(null);  // Reset after closing
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleEditProduct = (categories) => {
    setEditingData(categories)
    handleOpenModal(categories)
  };

  const handleDeleteProduct = (id) => {
    removeCategories(id.id);
  };

  // if (loading) return <p className="text-center">Loading...</p>;
  
  return (
    <>
      <NavbarComp />
      <Container fluid className="mt-2 mt-md-5">
        <Button Tooltip={"test"} variant="outline-success" className="mb-2" onClick={handleOpenModal}>
          <IoAddCircleOutline size={32} />
        </Button>
        <CategoriesTable
          categories={categories}
          onEdit={handleEditProduct}
          onDelete={handleDeleteProduct}
          updateOnActive={updateOnActive}
        />
      </Container>
      <CategoriesModalAdd
        show={showModal}
        handleClose={handleCloseModal}
        handleAddCategories={addCategories}
        parsingDataEdit={editingData}
      />
    </>
  );
};

export default CategoriesPage;
